import { ActivatedRouteSnapshot } from '@angular/router';
import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RouterStateSnapshot } from '@angular/router';
import { env } from  '../../environments/environment';

@Injectable()
export class DirectAccessGuard implements CanActivate {

  constructor(private router: Router) {}

  public canActivate(activated: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if(env.production && !this.router.navigated) {
      console.warn('Page not allowed on refresh. Going back...');
      
      this.router.navigateByUrl('');
      return false;
    }

    return true;
  }

}
